module.exports = __webpack_public_path__ + "img/buttonMobile2.160c2b0d.png";